import { render, staticRenderFns } from "./SefosAccount.vue?vue&type=template&id=5446dd4d&"
import script from "./SefosAccount.vue?vue&type=script&lang=js&"
export * from "./SefosAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports